export const DocumentFileType = {
  File: 'file',
  Html: 'html',
  Link: 'link',
} as const;

export type DocumentFileType =
  (typeof DocumentFileType)[keyof typeof DocumentFileType];
